// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"89":"cd1fb4501ea269f3","195":"657b220963b37bce","384":"37285907d40f9e6d","949":"26ebd49eb0c226ca"}[chunkId] + ".css";
};